import { render, staticRenderFns } from "./ColegiadoForm.vue?vue&type=template&id=20e2dee4&scoped=true&"
import script from "./ColegiadoForm.vue?vue&type=script&lang=js&"
export * from "./ColegiadoForm.vue?vue&type=script&lang=js&"
import style0 from "./ColegiadoForm.vue?vue&type=style&index=0&id=20e2dee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2dee4",
  null
  
)

export default component.exports